import Pacman from "src/app/components/layout/Pacman";
import { QuotaMetricGrid } from "../../components";
import { useQuotaList } from "src/app/hooks";

const QuotaMetricGridContainer = () => {
    const { quotaList, loading } = useQuotaList();

    if (loading)
        return (
            <div className="h-100 w-100 d-flex justify-content-center align-items-center">
                <Pacman />
            </div>
        );
    return <QuotaMetricGrid quotaList={quotaList} />;
};

export default QuotaMetricGridContainer;
